/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useEffect, useReducer, useContext } from 'react';
import { eulaReducer, initState, UPDATE_STATE } from './EulaReducer';

import { useApi } from '../../api/apiProvider';
import { useLocale } from '../locale/LocaleProvider';
import * as urls from '../../api/api';
import { CLIENT_VILKAAR_ID } from '../../api/serviceInfo';

interface EulaContext {
  vilkaar: any;
}

export const EulaContext = createContext({} as EulaContext);

const EulaProvider = (props: { children: JSX.Element | JSX.Element[] }): JSX.Element => {
  const { children } = props;
  const { api } = useApi();
  const {
    currentLocale: { locale },
    localeInitialized,
  } = useLocale();

  const [state, dispatch] = useReducer(eulaReducer, initState);

  const updateState = (payload: any): void => {
    dispatch({ type: UPDATE_STATE, payload });
  };

  const { vilkaar, loadingVilkaar } = state;

  useEffect(() => {
    if (localeInitialized) {
      const l = locale === 'nb' ? 'nb-NO' : 'en-US';
      const url = urls.getVilkaar(CLIENT_VILKAAR_ID, l);
      updateState({ loadingVilkaar: true });
      api
        .get(url)
        .then((res: { data: { result: any[] } }) => {
          dispatch({ type: UPDATE_STATE, payload: { vilkaar: res.data.result[0] } });
        })
        .catch(() => {
          // Catcher ikke hvis det ikke er en arrow function her.
        })
        .finally(() => {
          updateState({ loadingVilkaar: false });
        });
    }
  }, [api, locale, localeInitialized]);

  useEffect(() => {
    if (!loadingVilkaar) {
      dispatch({ type: UPDATE_STATE });
    }
  }, [vilkaar, loadingVilkaar]);

  return <EulaContext.Provider value={{ vilkaar }}>{children}</EulaContext.Provider>;
};

export default EulaProvider;

export const useEula = (): EulaContext => useContext(EulaContext);
